<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入关键字"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.type"
        placeholder="类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in PRODUCT_TYPE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in PRODUCT_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <!--      <el-select-->
      <!--        v-model="listQuery.merchantId"-->
      <!--        placeholder="商家"-->
      <!--        style="width: 120px"-->
      <!--        class="filter-item"-->
      <!--        clearable-->
      <!--      >-->
      <!--        <el-option-->
      <!--          v-for="item in []"-->
      <!--          :key="item.key"-->
      <!--          :label="item.value"-->
      <!--          :value="item.key"-->
      <!--        />-->
      <!--      </el-select>-->
      <ShopOption
        :refValue="listQuery.shopId"
        class="filter-item"
        type="formShop"
        :styleRef="{ width: '200px' }"
        @valueFunc="getShopValueFunc"
      />
      <Category
        :value="listQuery.categoryId"
        @valueFunc="getCategoryValueFunc"
        type="queryCategory"
        :styleRef="{ width: '200px', marginRight: '10px' }"
        class="filter-item"
        :showLevels="false"
      />
      <el-select
        v-model="listQuery.deleted"
        placeholder="是否已删除"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in PRODUCT_IS_DELETE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="create"
        startPlaceholder="创建开始时间"
        endPlaceholder="创建截止时间"
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {}, 'CREATE')"
        >新增</el-button
      >
      <el-button
        class="filter-item"
        icon="el-icon-download"
        @click="handleExport"
        style="margin-left: 10px"
        >导出</el-button
      >
    </div>

    <div style="margin-bottom: 5px">商品数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="95"
      ></el-table-column>
      <el-table-column
        label="商户名称"
        align="center"
        prop="mchName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="店铺名称"
        align="center"
        prop="shopName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="品牌名称"
        align="center"
        prop="brandName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="商品名称"
        align="left"
        prop="name"
        width="300"
      ></el-table-column>
      <el-table-column
        label="原价"
        align="center"
        prop="adPrice"
      ></el-table-column>
      <el-table-column
        label="供货价"
        align="center"
        prop="supplyPrice"
      ></el-table-column>
      <el-table-column label="规格现价" align="center" prop="supplyPrice">
        <template slot-scope="scope">
          <span>{{ scope.row.minPrice }}</span>
          <span v-if="scope.row.maxPrice">~{{ scope.row.maxPrice }}</span>
        </template>
      </el-table-column>
      <!--      <el-table-column-->
      <!--        label="最小价格"-->
      <!--        align="center"-->
      <!--        prop="minPrice"-->
      <!--      ></el-table-column>-->
      <!--      <el-table-column-->
      <!--        label="最大价格"-->
      <!--        align="center"-->
      <!--        prop="maxPrice"-->
      <!--      ></el-table-column>-->
      <el-table-column
        label="限购数量"
        align="center"
        prop="buyLimit"
      ></el-table-column>
      <el-table-column
        label="主图地址"
        align="center"
        prop="mainGraph"
        width="200"
      >
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.mainGraph"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>

      <el-table-column label="是否删除" align="center" prop="isDelete">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isDelete ? 'danger' : 'info'">{{
            scope.row.isDelete ? "是" : "否"
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="类目名称"
        align="center"
        prop="caterotyName"
        width="200"
      >
      </el-table-column>
      <el-table-column label="类型" align="center" prop="type">
        <template slot-scope="scope">
          {{ getValue(PRODUCT_TYPE, scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag
            style="color: #FFFFFF;"
            :color="getValue(PRODUCT_STATUS_CSS, scope.row.status)"
            >{{ getValue(PRODUCT_STATUS, scope.row.status) }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="创建时间"
        width="180"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="mddate"
        label="修改时间"
        width="180"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="280"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="checkExamineVisible(true, scope.row)"
            class="comm_but_warp"
            v-if="scope.row.status === 0"
            >审核</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="checkDialogFormVisible(true, scope.row, 'UPDATE')"
            class="comm_but_warp"
            v-if="!scope.row.isDelete"
            >编辑</el-button
          >
          <el-button
            type="success"
            plain
            size="mini"
            @click="upDownGoods(scope.row)"
            v-if="scope.row.status === 1"
            >上架</el-button
          >
          <el-button
            type="warning"
            size="mini"
            @click="upDownGoods(scope.row)"
            v-if="scope.row.status === 2"
            >下架</el-button
          >
          <el-button
            type="warning"
            plain
            size="mini"
            @click="jumpinfo(scope.row)"
            class="comm_but_warp"
            >预览</el-button
          >
          <el-button
            type="danger"
            size="mini"
            plain
            @click="deleteGoods(scope.row)"
            class="comm_but_warp"
            v-if="!scope.row.isDelete"
            >删除</el-button
          >
          <el-button
            type="success"
            size="mini"
            @click="deleteGoods(scope.row)"
            class="comm_but_warp"
            v-if="scope.row.isDelete"
            >恢复</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--    审核-->
    <el-dialog
      title="审核"
      :visible.sync="examineVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        ref="examineForm"
        :rules="examineRules"
        :model="examineForm"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="商户名称">
          <span>{{ examineObj.mchName }}</span>
        </el-form-item>
        <el-form-item label="店铺名称">
          <span>{{ examineObj.shopName }}</span>
        </el-form-item>
        <el-form-item label="品牌名称">
          <span>{{ examineObj.brandName }}</span>
        </el-form-item>
        <el-form-item label="类目名称">
          <span>{{ examineObj.caterotyName }}</span>
        </el-form-item>
        <el-form-item label="类型">
          <span>{{ getValue(PRODUCT_TYPE, examineObj.type) }}</span>
        </el-form-item>
        <el-form-item label="商品主图">
          <el-image
            style="width: 100px; height: 100px"
            :src="examineObj.mainGraph"
            fit="cover"
          ></el-image>
        </el-form-item>
        <el-form-item label="审核结果" prop="status">
          <el-select
            v-model="examineForm.status"
            placeholder="状态"
            style="width: 100%"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in PRODUCT_EXAMINE_STATUS"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkExamineVisible(false, {})">取消</el-button>
        <el-button type="primary" @click="examineOk">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getGoodsList,
  checkGoods,
  upDownGoods,
  deleteGoods,
  exportGoodsList
} from "@/api/product";
import { formatApiDate } from "@/utils/utils";
import { uploadXlsx } from "@/utils";
import { PRODUCT_STATUS_CSS } from "@/utils/enumUtileCss";
import {
  DIALOG_TITLE_TYPE,
  getValue,
  PRODUCT_EXAMINE_STATUS,
  PRODUCT_TYPE,
  PRODUCT_STATUS,
  PRODUCT_IS_DELETE
} from "@/utils/enumUtile";
import Category from "@/views/components/category.vue";
import ShopOption from "@/views/components/shopOption.vue";
import DataPicker from "@/views/components/dataPicker.vue";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    PRODUCT_EXAMINE_STATUS() {
      return PRODUCT_EXAMINE_STATUS;
    },
    PRODUCT_TYPE() {
      return PRODUCT_TYPE;
    },
    PRODUCT_STATUS() {
      return PRODUCT_STATUS;
    },
    PRODUCT_IS_DELETE() {
      return PRODUCT_IS_DELETE;
    },
    PRODUCT_STATUS_CSS() {
      return PRODUCT_STATUS_CSS;
    }
  },
  components: { DataPicker, Category, ShopOption },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        keyword: null,
        type: null,
        status: null,
        merchantId: null,
        shopId: null,
        brandId: null,
        categoryId: null,
        deleted: null,
        createStartTime: null,
        createEndTime: null
      },
      examineVisible: false, // 审核的弹框
      examineObj: {}, // 审核的弹框
      examineRules: {
        status: [
          { required: true, message: "审核结果不能为空", trigger: "change" }
        ]
      },
      examineForm: {
        id: 0, //
        status: null
      }
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      if (form.categoryId && form.categoryId.length !== 0) {
        params.categoryId = form.categoryId[form.categoryId.length - 1];
      }
      getGoodsList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 获取店铺
     * @param type
     * @param resultArr
     */
    getShopValueFunc(type, resultArr) {
      if (type === "formShop") {
        this.form.shopId = resultArr;
      }
    },
    /**
     * 切换状态
     * @param status
     * @param editObj
     * @param type
     */
    checkDialogFormVisible(status, editObj = {}, type) {
      if (type === "CREATE") {
        this.$router.push({ path: "/product/list/add" });
      } else {
        this.$router.push({ path: "/product/list/edit/" + editObj.id });
      }
    },

    // 审核 start
    checkExamineVisible(val, obj = {}) {
      this.examineObj = obj;
      if (obj && Object.keys(obj).length !== 0) {
        this.examineForm.id = obj.id;
      }
      this.examineVisible = val;
    },
    examineOk() {
      this.$refs["examineForm"].validate(valid => {
        if (valid) {
          const form = this.examineForm;
          const params = {
            ...form
          };
          checkGoods(params).then(() => {
            this.getList();
            this.checkExamineVisible(false);
            this.$notify({
              title: "成功",
              message: "审核成功",
              type: "success",
              duration: 2000
            });
          });
        }
      });
    },
    // 审核 end

    /**
     * 获取主营类目
     * @param type
     * @param resultArr
     */
    getCategoryValueFunc(type, resultArr) {
      if (type === "queryCategory") {
        this.listQuery.categoryId = resultArr;
      }
    },
    /**
     * 上下架商品
     * @param item
     */
    upDownGoods(item) {
      const params = {
        id: item.id,
        status: item.status === 1 ? 2 : 1
      };
      this.btnLoading = true;
      upDownGoods(params)
        .then(() => {
          this.getList();
          this.checkExamineVisible(false);
          this.$notify({
            title: "成功",
            message: item.status === 1 ? "上架" : "下架" + "成功",
            type: "success",
            duration: 2000
          });
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    /**
     * 删除商品
     * @param item
     */
    deleteGoods(item) {
      const deleteGoodsMsg = item.isDelete
        ? "确认要恢复该商品？"
        : "删除该商品后不可恢复，确认删除该商品？";
      this.$confirm(deleteGoodsMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const params = {
          id: item.id,
          status: item.isDelete ? 2 : 1
        };
        this.btnLoading = true;
        deleteGoods(params)
          .then(() => {
            this.getList();
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
              duration: 2000
            });
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    /**
     * 预览
     * @param item
     */
    jumpinfo(item) {
      this.$router.push({ path: "/product/list/info/" + item.id });
    },

    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      if (type === "create") {
        this.listQuery.createStartTime = value[0];
        this.listQuery.createEndTime = value[1];
      }
    },
    /**
     * 导出
     */
    handleExport() {
      const form = this.listQuery;
      const params = {
        ...form
      };
      exportGoodsList(params).then(response => {
        uploadXlsx(response, "商品表");
      });
    }
  }
};
</script>
<style scoped lang="scss">
.el-dropdown-link {
  cursor: pointer;
  margin-left: 10px;
}
.comm_but_warp {
  margin-bottom: 10px;
}
</style>
